/*
 * Author: Dw
 * File Created: Monday, 24-08-05 02:05 pm
 * Last Modified: Monday, 25-03-17 03:17 pm, by Harper Yan
 */

import React, { useEffect, useState } from 'react';
import { Flex } from '@ucard/ds/containers';
import MobileHeader from './MobileHeader';
import PcHeader from './PcHeader';
import useHeaderConfig from './useHeaderConfig';
interface HeaderProps {
  vip?: boolean;
}
const Header: React.FC<HeaderProps> = ({
  vip
}: HeaderProps) => {
  const {
    configs,
    isMobile
  } = useHeaderConfig(vip);
  const [hasMounted, setHasMounted] = useState(false);
  const [bgColor, setBgColor] = useState('rgba(28, 28, 28, 1)');
  useEffect(() => {
    setHasMounted(true);
  }, []);
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollTop = window.scrollY;
          const opacity = Math.min(scrollTop / 200, 1);
          setBgColor(`rgba(28, 28, 28, ${opacity})`);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', handleScroll);

    // 清理函数
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  if (!hasMounted) {
    // 在客户端渲染完成之前不显示任何内容，避免闪烁
    return null;
  }
  return <Flex bgcolor={bgColor} justifyContent="center" position="fixed" py={[0, 1.5]} width="100vw" zIndex={100000} data-sentry-element="Flex" data-sentry-component="Header" data-sentry-source-file="index.tsx">
      {isMobile ? <MobileHeader configs={configs} /> : <PcHeader configs={configs} />}
    </Flex>;
};
export default Header;